(function(){
  const root=document.getElementById('jdp-acbnt-page'); if(!root) return;

  function restoreLogoStrip(){
    const strip=root.querySelector('.jdp-v2-logo-strip ul');
    if(!strip) return;
    strip.innerHTML=''
      + '<li><img src="https://cdn.shopify.com/s/files/1/0678/1380/2266/files/JDP.svg?v=1781348123" alt="JDP" loading="lazy"></li>'
      + '<li><img src="https://cdn.shopify.com/s/files/1/0678/1380/2266/files/ACBNT_LOGO.svg?v=1781348123" alt="ACBNT" loading="lazy"></li>'
      + '<li><img src="https://cdn.shopify.com/s/files/1/0678/1380/2266/files/AQF.svg?v=1781348123" alt="AQF" loading="lazy"></li>'
      + '<li><img src="https://cdn.shopify.com/s/files/1/0678/1380/2266/files/NRT_COLOUR.svg?v=1781384269" alt="NRT" loading="lazy"></li>';
    if(!document.getElementById('jdp-v2-logo-restore-css')){
      const style=document.createElement('style');
      style.id='jdp-v2-logo-restore-css';
      style.textContent="#jdp-acbnt-page .jdp-v2-logo-strip ul{display:flex!important;justify-content:center!important;align-items:center!important;gap:34px!important;flex-wrap:wrap!important;padding:18px 22px!important}#jdp-acbnt-page .jdp-v2-logo-strip li{display:flex!important;align-items:center!important;justify-content:center!important;min-width:96px!important;min-height:46px!important}#jdp-acbnt-page .jdp-v2-logo-strip img{display:block!important;width:auto!important;height:auto!important;max-width:132px!important;max-height:46px!important;object-fit:contain!important;filter:drop-shadow(0 8px 16px rgba(16,16,24,.08))!important}@media(max-width:640px){#jdp-acbnt-page .jdp-v2-logo-strip ul{gap:18px!important;padding:16px!important}#jdp-acbnt-page .jdp-v2-logo-strip li{min-width:72px!important}#jdp-acbnt-page .jdp-v2-logo-strip img{max-width:104px!important;max-height:38px!important}}";
      document.head.appendChild(style);
    }
  }
  restoreLogoStrip();

  const buttons=document.querySelectorAll('[data-jdp-lang-btn]');
  const textCache=new WeakMap(), phCache=new WeakMap();

  function getUrlLanguage(){
    try{
      const value=(new URL(window.location.href).searchParams.get('lang')||'').toLowerCase();
      if(value==='vi'||value==='viet'||value==='vietnamese') return 'vi';
      if(value==='en'||value==='eng'||value==='english') return 'en';
    }catch(e){}
    return null;
  }

  function updateLanguageUrl(lang){
    try{
      const url=new URL(window.location.href);
      url.searchParams.set('lang',lang);
      window.history.replaceState({},'',url.pathname+url.search+url.hash);
    }catch(e){}
  }

  function outcome(lang){
    const copy=[
      {en:'<strong class="jdp-free-word">Free</strong><br>$500 kit',vi:'Kit <strong class="jdp-free-word">miễn phí</strong><br>$500'},
      {en:'<strong class="jdp-free-word">Free</strong><br>up to $2,268 kit',vi:'Kit <strong class="jdp-free-word">miễn phí</strong><br>tối đa $2,268'},
      {en:'<strong class="jdp-free-word">Free</strong><br>up to $1,768 kit',vi:'Kit <strong class="jdp-free-word">miễn phí</strong><br>tối đa $1,768'},
      {en:'<strong class="jdp-free-word">Free</strong><br>up to $2,268 kit',vi:'Kit <strong class="jdp-free-word">miễn phí</strong><br>tối đa $2,268'}
    ];
    root.querySelectorAll('.jdp-path-card').forEach((card,i)=>{
      const span=card.querySelector('.jdp-path-outcome span'); if(span&&copy[i]) span.innerHTML=lang==='vi'?copy[i].vi:copy[i].en;
      const cta=card.querySelector('.jdp-path-cta'); if(cta) cta.textContent=lang==='vi'?'Nhận tư vấn':'Get course advice';
    });
  }
  function setLanguage(lang,syncUrl){
    lang=lang==='vi'?'vi':'en'; root.dataset.lang=lang; document.documentElement.lang=lang;
    buttons.forEach(btn=>{const active=btn.dataset.jdpLangBtn===lang;btn.classList.toggle('is-active',active);btn.setAttribute('aria-pressed',active?'true':'false')});
    root.querySelectorAll('[data-jdp-vi]').forEach(el=>{if(!textCache.has(el)) textCache.set(el,el.textContent);el.textContent=lang==='vi'?el.getAttribute('data-jdp-vi'):textCache.get(el)});
    root.querySelectorAll('[data-jdp-vi-ph]').forEach(el=>{if(!phCache.has(el)) phCache.set(el,el.getAttribute('placeholder')||'');el.setAttribute('placeholder',lang==='vi'?el.getAttribute('data-jdp-vi-ph'):phCache.get(el))});
    outcome(lang); restoreLogoStrip(); if(syncUrl!==false) updateLanguageUrl(lang); try{localStorage.setItem('jdp-acbnt-lang',lang)}catch(e){}
  }
  buttons.forEach(btn=>btn.addEventListener('click',()=>setLanguage(btn.dataset.jdpLangBtn,true)));
  let saved='en'; try{saved=localStorage.getItem('jdp-acbnt-lang')||'en'}catch(e){}
  const urlLang=getUrlLanguage(), initialLang=urlLang||(saved==='vi'?'vi':'en');
  setLanguage(initialLang,false);
  window.jdpAcbntSetLanguage=lang=>setLanguage(lang,true);
  window.addEventListener('popstate',()=>{const lang=getUrlLanguage(); if(lang) setLanguage(lang,false)});
  const form=document.getElementById('jdpLeadForm'), status=document.getElementById('jdpStatus'), confirmBox=document.getElementById('jdpConfirm'), endpoint=root.dataset.endpoint;
  function tr(en,vi){return root.dataset.lang==='vi'?vi:en}
  if(!form) return;
  form.addEventListener('submit',async function(event){
    event.preventDefault(); confirmBox.classList.remove('is-visible'); status.textContent=tr('Submitting your enquiry...','Đang gửi yêu cầu tư vấn...');
    const formData=new FormData(form), interests=formData.getAll('interest'), payload=Object.fromEntries(formData.entries());
    payload.selectedSpecialistWorkshops=interests.join(', '); payload.leadSource='JDP'; payload.campaign='JDP_ACBNT_EDUCATION_V2'; payload.pageUrl=window.location.href; payload.language=root.dataset.lang==='vi'?'Vietnamese':'English'; payload.consentAccepted=formData.get('consentAccepted')?'yes':'no';
    if(!endpoint){status.textContent=tr('Form is not connected yet. Please call ACBNT on 0489 948 706.','Form chưa được kết nối. Vui lòng gọi ACBNT qua số 0489 948 706.');return}
    try{
      const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)});
      const data=await response.json(); if(!data||!data.ok) throw new Error((data&&data.error)||'Submission failed'); const reference=data.reference||'Pending';
      try{if(window.fbq){fbq('track','Lead',{content_name:'JDP ACBNT Enquiry V2',lead_source:'landing_page',reference})}window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'jdp_acbnt_lead_submit',lead_source:'landing_page',reference})}catch(e){}
      status.textContent=tr('Enquiry received.','Đã nhận yêu cầu tư vấn.'); confirmBox.innerHTML='<b>'+tr('Your JDP reference:','Mã tham chiếu JDP:')+'</b> <code>'+reference+'</code>'; confirmBox.classList.add('is-visible'); form.reset();
      window.setTimeout(()=>{window.location.href='/pages/jdp-acbnt-thank-you?ref='+encodeURIComponent(reference)},700);
    }catch(error){status.textContent=tr('Something went wrong. Please call ACBNT on 0489 948 706 or try again later.','Có lỗi xảy ra. Vui lòng gọi ACBNT qua số 0489 948 706 hoặc thử lại sau.')}
  });
})();

(function(){
  const root=document.getElementById('jdp-acbnt-page');
  if(!root) return;

  const cards=[
    {enTitle:'BIAB Pro Kit',viTitle:'Kit BIAB Pro',enDesc:'For BIAB structure gel training.',viDesc:'Dành cho khóa học gel cấu trúc BIAB.',enNote:'Included with eligible enrolment package.',viNote:'Bao gồm với gói ghi danh đủ điều kiện.'},
    {enTitle:'Builder Gel Pro Kit',viTitle:'Kit Builder Gel Pro',enDesc:'For hard gel / builder gel training.',viDesc:'Dành cho khóa học Hard Gel / Builder Gel.',enNote:'Confirmed with your pathway.',viNote:'Được xác nhận theo lộ trình của bạn.'},
    {enTitle:'Polygel Pro Kit',viTitle:'Kit Polygel Pro',enDesc:'For hybrid gel / polygel training.',viDesc:'Dành cho khóa học Hybrid Gel / Polygel.',enNote:'Confirmed with your pathway.',viNote:'Được xác nhận theo lộ trình của bạn.'},
    {enTitle:'Nail Art Pro Kit',viTitle:'Kit Nail Art Pro',enDesc:'For specialist nail art practice.',viDesc:'Dành cho thực hành Nail Art chuyên sâu.',enNote:'Confirmed with your pathway.',viNote:'Được xác nhận theo lộ trình của bạn.'},
    {enTitle:'Accredited Acrylic Kit',viTitle:'Kit Acrylic được công nhận',enDesc:'For SHBBNLS009 acrylic pathway.',viDesc:'Dành cho lộ trình Acrylic SHBBNLS009.',enNote:'Included with eligible accredited enrolment.',viNote:'Bao gồm với ghi danh chương trình được công nhận đủ điều kiện.'},
    {enTitle:'Accredited Nail Art Kit',viTitle:'Kit Nail Art được công nhận',enDesc:'For SHBBNLS010 nail art pathway.',viDesc:'Dành cho lộ trình Nail Art SHBBNLS010.',enNote:'Included with eligible accredited enrolment.',viNote:'Bao gồm với ghi danh chương trình được công nhận đủ điều kiện.'}
  ];

  function ensurePriceStyle(){
    if(document.getElementById('jdp-kit-viet-price-style')) return;
    const style=document.createElement('style');
    style.id='jdp-kit-viet-price-style';
    style.textContent='#jdp-acbnt-page[data-lang="vi"] .jdp-kit-value-pill s:before{content:"Kit trị giá "!important}#jdp-acbnt-page[data-lang="vi"] .jdp-kit-value-pill s:after{content:""!important}';
    document.head.appendChild(style);
  }

  function applyKitLanguage(){
    ensurePriceStyle();
    const vi=root.getAttribute('data-lang')==='vi';
    root.querySelectorAll('.jdp-kit-card').forEach((card,index)=>{
      const copy=cards[index];
      if(!copy) return;
      const title=card.querySelector('.jdp-kit-card__body > b');
      const desc=card.querySelector('.jdp-kit-card__body > small');
      const note=card.querySelector('.jdp-kit-subnote');
      const free=card.querySelector('.jdp-kit-value-pill strong');
      if(title) title.textContent=vi?copy.viTitle:copy.enTitle;
      if(desc) desc.textContent=vi?copy.viDesc:copy.enDesc;
      if(note) note.textContent=vi?copy.viNote:copy.enNote;
      if(free) free.textContent=vi?'Miễn phí':'Free';
    });
  }

  const originalSetLanguage=window.jdpAcbntSetLanguage;
  if(typeof originalSetLanguage==='function'){
    window.jdpAcbntSetLanguage=function(lang){
      originalSetLanguage(lang);
      applyKitLanguage();
    };
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',applyKitLanguage); else applyKitLanguage();
  document.addEventListener('click',event=>{
    if(event.target&&event.target.matches('[data-jdp-lang-btn]')) window.setTimeout(applyKitLanguage,0);
  });
  window.addEventListener('popstate',()=>window.setTimeout(applyKitLanguage,0));
  document.addEventListener('shopify:section:load',applyKitLanguage);
})();